"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBreakpoints = void 0;
const material_1 = require("@mui/material");
const react_1 = require("react");
function useBreakpoints(boundaries) {
    const [list, setList] = (0, react_1.useState)(boundaries.reduce((defaultList, boundary) => (Object.assign(Object.assign({}, defaultList), { [boundary]: false })), {}));
    const breakpoints = boundaries.reduce((newList, boundary) => {
        const type = boundary.substring(2) === 'Up' ? 'up' : 'down';
        const breakpoint = boundary.substr(0, 2);
        const status = (0, material_1.useMediaQuery)((theme) => theme.breakpoints[type](breakpoint));
        return Object.assign(Object.assign({}, newList), { [boundary]: status });
    }, Object.assign({}, list));
    (0, react_1.useEffect)(() => setList(breakpoints), [...Object.values(breakpoints)]);
    return list;
}
exports.useBreakpoints = useBreakpoints;
exports.default = useBreakpoints;
